
 //import { Component, OnInit, Input } from '@angular/core';
//import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ItemModifierService } from "src/app/ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../store/userInfo.store";


@Component({
  selector: 'app-product-block',
  templateUrl: './product-block.component.html',
  styleUrls: ['./product-block.component.scss']
})
export class ProductBlockComponent implements OnInit {

  @Input() productImgURL1:string="../../../assets/styles/images/product/2.jpg";
  @Input() productImgURL2:string="../../../assets/styles/images/product/2.jpg";
  @Input() productURL:string="#/single-product";
  @Input() productName:string="robin parrish";
  @Input() currentPrize:string="$35.00";
  @Input() oldPrize:string="$35.00";

  @Input() saveAmount:string="$00.00";
  @Input() savePercent:string="$0.00";

  @Input() productDescription:string="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";
  @Input() itemId:string="1";
  @Input() sku:string="1";
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private itemModifierService: ItemModifierService,
    private infoStore: UserInfoStore

    ) { }

  ngOnInit() {

  }


  routeSingle(itemId,sku){
    this.router.navigateByUrl("/single-product/"+itemId+"&"+sku)
  }


  addToCart() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        ApplicationItemCategoryId: 4,
        OrderStatusID: 2,
        OrderShippingCategoryID: 0,
        OrderPaymentTypeId: 0,
        PackingId: 0,
        TrackId: 0,
        SKUCode: this.sku,
        Qty: 1,
        CreatedBy: 55,
        Notes:null,
        OperationType: "insert",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Saved") {
            alert("Add To Cart Successfully !");
            this.getCartInfo();
          }
        }
      });
    } else {
      alert("Please Login");
      this.router.navigateByUrl("login");
    }
  }

  addToWishlist() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        ApplicationItemCategoryId: 3,
        OrderStatusID: 2,
        OrderShippingCategoryID: 0,
        OrderPaymentTypeId: 0,
        PackingId: 0,
        TrackId: 0,
        SKUCode: this.sku,
        Qty: 1,
        CreatedBy: 55,
        Notes:null,
        OperationType: "insert",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Saved") {
            alert("Add To WishList Successfully !");
          }
        }
      });
    } else {
      alert("Please Login");
      this.router.navigateByUrl("login");
      
    }
  }

  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }


}
